import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { authServices } from '../services/auth.service';

export const useUploadPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ file, adminId }) => {
      // Step 1: Upload file to /admin/upload
      const uploadResponse = await authServices.uploadFile(file);
      const photoKey = uploadResponse?.data?.key;

      if (!photoKey) {
        throw new Error('Failed to get photo key from upload response');
      }

      // Step 2: Update admin profile with the photo key
      const updateResponse = await authServices.updateProfilePhoto(adminId, photoKey);
      return updateResponse;
    },
    onSuccess: () => {
      toast.success('Profile photo updated successfully');
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || error?.message || 'Failed to upload photo';
      toast.error(message);
    },
  });
};
